module.exports = __webpack_public_path__ + "img/change-password.b100c3c4.svg";